import { Skeleton } from 'antd'

const Loading = () => {
  return (
    <div className='flex flex-col gap-5'>
        <Skeleton />
        <Skeleton />
        <Skeleton />
    </div>
  )
}

export default Loading
